(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["45R-main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["45R-wishlist"] && !Shopify.designMode) return;
  try {
    
(function() {
  const ICON_ORDER = ['PRE ORDER', 'COMING SOON', 'LIMITED TIME', 'ONLINE EXCLUSIVE', 'ONLINE OFFERING', 'NEW', 'UNISEX'];

  let translations = {};
  try {
    const el = document.getElementById('wishlist-translations');
    if (el) translations = JSON.parse(el.textContent);
  } catch (e) {}
  const icons = translations.icons || {};
  var rootUrl = (translations.rootUrl || '/');
  if (rootUrl.charAt(rootUrl.length - 1) !== '/') rootUrl += '/';

  function initWishlistPage() {
    const container = document.getElementById('swym-wishlist');
    const emptyState = document.querySelector('[data-wishlist-empty]');
    const loadingState = document.querySelector('[data-wishlist-loading]');
    if (!container || !emptyState) return;

    function showLoading() {
      if (loadingState) loadingState.classList.remove('is-hidden');
      container.style.display = 'none';
      emptyState.classList.remove('is-visible');
    }

    function hideLoading() {
      if (loadingState) loadingState.classList.add('is-hidden');
    }

    function showEmpty() {
      hideLoading();
      container.innerHTML = '';
      container.style.display = 'none';
      emptyState.classList.add('is-visible');
    }

    function hideEmpty() {
      emptyState.classList.remove('is-visible');
      container.style.display = 'grid';
    }

    function formatPrice(price) {
      if (!price) return '';
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: Shopify.currency?.active || 'USD'
      }).format(price);
    }

    function getProductHandle(url) {
      if (!url) return null;
      const match = url.match(/\/products\/([^?#/]+)/);
      return match ? match[1] : null;
    }

    const productDataCache = {};

    async function fetchProductData(handle) {
      if (productDataCache[handle] !== undefined) {
        return productDataCache[handle];
      }
      try {
        const res = await fetch(rootUrl + 'products/' + handle + '.json');
        if (res.ok) {
          const data = await res.json();
          productDataCache[handle] = data.product;
          return data.product;
        }
      } catch (e) {}
      productDataCache[handle] = null;
      return null;
    }

    // Same badge markup as 45R-product-icons, built from the tag: the
    // class and the label both derive from it, and the labels come from
    // the icons map so this matches the product cards in every locale.
    function badgeHtml(tag) {
      const cls = tag.toLowerCase().replace(/ /g, '-');
      const label = icons[cls.replace(/-/g, '_')] || tag;
      return '<span class="product-icon-45R product-icon-45R--' + cls + '">' + label + '</span>';
    }

    function buildIconsHtml(product, isAvailable) {
      let html = [];
      if (product && product.tags) {
        ICON_ORDER.forEach(function(name) {
          if (product.tags.includes(name)) html.push(badgeHtml(name));
        });
      }
      if (!isAvailable) html.push(badgeHtml('SOLD OUT'));
      return html.join('');
    }

    function getProductImages(productData, mainImageUrl) {
      const images = [];
      if (mainImageUrl) images.push(mainImageUrl);
      if (productData && productData.images) {
        productData.images.forEach(function(img) {
          const src = img.src || img;
          if (src && !images.includes(src)) images.push(src);
        });
      }
      return images.slice(0, 10);
    }

    const productHtmlCache = {};

    async function fetchProductHtml(handle) {
      if (productHtmlCache[handle] !== undefined) {
        return productHtmlCache[handle];
      }
      try {
        const res = await fetch(rootUrl + 'products/' + handle);
        if (res.ok) {
          const html = await res.text();
          productHtmlCache[handle] = html;
          return html;
        }
      } catch (e) {}
      productHtmlCache[handle] = null;
      return null;
    }

    function extractProductTitle(html) {
      if (!html) return null;
      const titleMatch = html.match(/<h1[^>]*class="[^"]*product-details-45R__title[^"]*"[^>]*>([\s\S]*?)<\/h1>/i);
      if (titleMatch && titleMatch[1]) {
        return titleMatch[1].replace(/<[^>]*>/g, '').trim();
      }
      return null;
    }

    async function fetchVariantAvailability(handle, variantId) {
      const result = { available: true, inventoryQuantity: null, productTitle: null, isComingSoon: false };
      try {
        const vid = String(variantId).replace(/\D/g, '');
        if (!vid) return result;

        const html = await fetchProductHtml(handle);

        if (html) {
          result.productTitle = extractProductTitle(html);

          /* Countdown-driven Coming Soon detection — the product page only
             emits <div data-r45-countdown ...> when an active product_countdown
             metaobject entry targets the product. Cheap substring scan over the
             HTML we already fetched; no extra round-trip. Replaces the legacy
             COMING SOON tag check so wishlist now blocks purchase the same way
             the product page does, even though the tag is gone. */
          if (html.indexOf('data-r45-countdown') !== -1) {
            result.isComingSoon = true;
          }

          const variantScriptMatch = html.match(/<script[^>]*data-product-variants[^>]*>([\s\S]*?)<\/script>/i);
          if (variantScriptMatch) {
            try {
              const variants = JSON.parse(variantScriptMatch[1]);
              const variant = variants.find(function(v) { return String(v.id) === vid; });
              if (variant) {
                result.available = !!variant.available;
                if (typeof variant.inventory_quantity === 'number') {
                  result.inventoryQuantity = variant.inventory_quantity;
                }
              }
            } catch (e) {}
          }
        }
      } catch (e) {
        console.error('Availability check error:', e);
      }
      return result;
    }

    function getVariantInfo(productData, variantId) {
      if (!productData || !productData.variants) return null;
      const variant = productData.variants.find(function(v) {
        return String(v.id) === String(variantId);
      });
      if (!variant) return null;

      const info = {};
      if (variant.option1) info.color = variant.option1;
      if (variant.option2) info.size = variant.option2;
      if (variant.option3) info.option3 = variant.option3;
      if (typeof variant.inventory_quantity === 'number') {
        info.inventoryQuantity = variant.inventory_quantity;
      }
      /* Shopify product.json returns prices as strings in the shop's major
         unit (e.g. "29.95"). Convert to number once so the card render can
         do a simple compare-vs-compare-at check. */
      if (variant.price !== undefined && variant.price !== null) {
        const p = parseFloat(variant.price);
        if (!isNaN(p)) info.price = p;
      }
      if (variant.compare_at_price !== undefined && variant.compare_at_price !== null) {
        const cp = parseFloat(variant.compare_at_price);
        if (!isNaN(cp)) info.compareAtPrice = cp;
      }
      return info;
    }

    function createCardHtml(item, productData, isAvailable, variantInfo, isFirstCard, productTitle) {
      const iconsHtml = buildIconsHtml(productData, isAvailable);
      const images = getProductImages(productData, item.iu);
      const hasMultiple = images.length > 1;

      /* Two Coming Soon sources kept compatible: the legacy product tag
         (if a merchant still relies on it) and the new countdown
         metaobject (surfaced via variantInfo.isComingSoon, populated from
         the data-r45-countdown marker on the product page). Either trips
         the disabled cart button, so wishlist purchase mirrors the
         product-page CTA exactly. */
      const isComingSoonByTag = productData && productData.tags && productData.tags.includes('COMING SOON');
      const isComingSoonByCountdown = variantInfo && variantInfo.isComingSoon;
      const isComingSoon = isComingSoonByTag || isComingSoonByCountdown;
      const canAddToCart = isAvailable && !isComingSoon;

      /* Price block. Variant-level compare_at_price drives the sale
         treatment so the card reads the same as the cart and the product
         page when a product is currently discounted. Fall back to the
         Swym-cached item.pr only if the Shopify variant data was missing
         (e.g. product unpublished). */
      const variantPrice = variantInfo && typeof variantInfo.price === 'number'
        ? variantInfo.price
        : item.pr;
      const variantCompareAtPrice = variantInfo && typeof variantInfo.compareAtPrice === 'number'
        ? variantInfo.compareAtPrice
        : null;
      const showCompare = variantCompareAtPrice && variantCompareAtPrice > variantPrice;
      const priceHtml = showCompare
        ? `<span class="r45-wishlist-card__price-sale">${formatPrice(variantPrice)}</span><s class="r45-wishlist-card__price-compare">${formatPrice(variantCompareAtPrice)}</s>`
        : `<span>${formatPrice(variantPrice)}</span>`;

      const displayTitle = productTitle || item.dt || (translations.product || 'Product');

      const imagesHtml = images.map(function(src, idx) {
        const baseUrl = src.split('?')[0];
        const altText = idx === 0 ? displayTitle : displayTitle + ' - image ' + (idx + 1);
        const srcset = baseUrl + '?width=400 400w, ' + baseUrl + '?width=600 600w, ' + baseUrl + '?width=800 800w';
        const sizes = '(max-width: 768px) 50vw, (max-width: 1024px) 33vw, 25vw';
        const isLCPImage = isFirstCard && idx === 0;
        const loadingAttr = isLCPImage ? '' : ' loading="lazy"';
        const priorityAttr = isLCPImage ? ' fetchpriority="high"' : '';
        return '<div class="r45-wishlist-card__image"><img src="' + baseUrl + '?width=600" srcset="' + srcset + '" sizes="' + sizes + '" alt="' + altText + '"' + loadingAttr + priorityAttr + ' decoding="async"></div>';
      }).join('');

      const removeIcon = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false"><path class="remove-icon-bottom" d="M11.5 9v4.25M8.5 9v4.25M5.75 12.2V6h8.5c0 2.421 0 3.779 0 6.2 0 .853 0 1.447-.038 1.91-.037.453-.106.714-.207.911a2.498 2.498 0 0 1-.983 1.017c-.197.1-.458.17-.911.207-.463.037-1.057.038-1.91.038h-.4c-.853 0-1.447 0-1.91-.038-.453-.037-.714-.106-.911-.207a2.498 2.498 0 0 1-.984-1.017c-.1-.197-.17-.458-.207-.911C5.75 13.647 5.75 13.053 5.75 12.2z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path class="remove-icon-top" d="M4.25 6h11.5M8 5.25a2 2 0 1 1 4 0" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      let variantHtml = '';
      if (variantInfo) {
        const parts = [];
        if (variantInfo.color) parts.push(variantInfo.color);
        if (variantInfo.size) parts.push(variantInfo.size);
        if (parts.length > 0) {
          const isLastOne = isAvailable && variantInfo.inventoryQuantity === 1;
          const lastOneHtml = isLastOne ? '<span class="r45-wishlist-card__last-one">' + (translations.lastOne || 'Last One') + '</span>' : '';
          variantHtml = '<div class="r45-wishlist-card__variant">' +
            '<span class="r45-wishlist-card__variant-text">' + parts.join(' / ') + '</span>' +
            lastOneHtml +
            '</div>';
        }
      }

      const productName = displayTitle;
      const prevImageLabel = translations.previousImage || 'Previous image';
      const nextImageLabel = translations.nextImage || 'Next image';

      let buttonText, addToCartLabel;
      if (isComingSoon) {
        buttonText = translations.comingSoon || 'Coming Soon';
        addToCartLabel = productName + ' - ' + buttonText;
      } else if (!isAvailable) {
        buttonText = translations.soldOut || 'Sold Out';
        addToCartLabel = productName + ' ' + buttonText;
      } else {
        buttonText = translations.addToBag || 'Add to Bag';
        addToCartLabel = (translations.addToCart || 'Add [product] to cart').replace('[product]', productName);
      }

      const removeLabel = (translations.removeFromWishlist || 'Remove [product] from wishlist').replace('[product]', productName);

      const isPublished = !!productData;

      const imageContainerInner = isPublished
        ? '<a href="' + item.du + '" class="r45-wishlist-card__image-link" aria-label="' + productName + '"><div class="r45-wishlist-card__image-slider" data-current="0" data-count="' + images.length + '">' + imagesHtml + '</div></a>'
        : '<div class="r45-wishlist-card__image-link"><div class="r45-wishlist-card__image-slider" data-current="0" data-count="' + images.length + '">' + imagesHtml + '</div></div>';

      const titleHtml = isPublished
        ? '<a href="' + item.du + '" class="r45-wishlist-card__title">' + productName + '</a>'
        : '<span class="r45-wishlist-card__title r45-wishlist-card__title--unavailable">' + productName + '</span>';

      return `
        <article class="r45-wishlist-card" data-product-id="${item.empi}" data-variant-id="${item.epi}" role="listitem">
          <div class="r45-wishlist-card__image-container">
            ${imageContainerInner}
            ${hasMultiple ? '<button type="button" class="r45-wishlist-card__arrow r45-wishlist-card__arrow--prev" data-dir="prev" aria-label="' + prevImageLabel + '"></button>' : ''}
            ${hasMultiple ? '<button type="button" class="r45-wishlist-card__arrow r45-wishlist-card__arrow--next" data-dir="next" aria-label="' + nextImageLabel + '"></button>' : ''}
          </div>
          <div class="r45-wishlist-card__content">
            ${iconsHtml ? '<div class="r45-wishlist-card__icons">' + iconsHtml + '</div>' : ''}
            ${titleHtml}
            ${variantHtml}
            <div class="r45-wishlist-card__price">${priceHtml}</div>
            <div class="r45-wishlist-card__actions">
              <button type="button" class="r45-wishlist-card__add-btn" ${!canAddToCart ? 'disabled aria-disabled="true"' : ''} data-add-to-cart aria-label="${addToCartLabel}">
                ${buttonText}
              </button>
              <button type="button" class="r45-wishlist-card__remove-btn" data-remove-wishlist aria-label="${removeLabel}">${removeIcon}</button>
            </div>
          </div>
        </article>
      `;
    }

    function initSlider(card) {
      const slider = card.querySelector('.r45-wishlist-card__image-slider');
      const prevBtn = card.querySelector('.r45-wishlist-card__arrow--prev');
      const nextBtn = card.querySelector('.r45-wishlist-card__arrow--next');
      if (!slider) return;

      const count = parseInt(slider.dataset.count) || 1;
      if (count <= 1) return;

      function goTo(index) {
        let current = index;
        if (current < 0) current = count - 1;
        if (current >= count) current = 0;

        slider.dataset.current = current;
        slider.style.transform = 'translateX(' + (-current * 100) + '%)';
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function(e) { e.preventDefault(); goTo((parseInt(slider.dataset.current) || 0) - 1); });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function(e) { e.preventDefault(); goTo((parseInt(slider.dataset.current) || 0) + 1); });
      }

      let startX = 0;
      slider.addEventListener('touchstart', function(e) { startX = e.changedTouches[0].screenX; }, { passive: true });
      slider.addEventListener('touchend', function(e) {
        const diff = startX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 50) goTo((parseInt(slider.dataset.current) || 0) + (diff > 0 ? 1 : -1));
      }, { passive: true });
    }

    function triggerSwipeHint() {
      const firstCard = container.querySelector('.r45-wishlist-card');
      const firstSlider = firstCard ? firstCard.querySelector('.r45-wishlist-card__image-slider[data-count]') : null;
      if (firstCard && firstSlider && parseInt(firstSlider.dataset.count) > 1) {
        setTimeout(function() {
          firstCard.classList.add('show-hint-arrow');
          firstSlider.classList.add('swipe-hint');
          setTimeout(function() {
            firstSlider.classList.remove('swipe-hint');
            firstCard.classList.remove('show-hint-arrow');
          }, 1200);
        }, 500);
      }
    }

    function animateFlyToCart(button, imageUrl) {
      const cartIcon = document.querySelector('.header-actions__cart-icon');
      if (!cartIcon || !imageUrl) return;

      const flyToCartElement = document.createElement('fly-to-cart');
      flyToCartElement.style.setProperty('background-image', 'url(' + imageUrl + ')');
      flyToCartElement.source = button;
      flyToCartElement.destination = cartIcon;
      document.body.appendChild(flyToCartElement);
    }

    async function addToCart(variantId, button) {
      const originalText = button.textContent;
      button.disabled = true;
      button.textContent = translations.adding || 'Adding...';

      const numericVariantId = parseInt(variantId, 10);
      if (!numericVariantId) {
        button.disabled = false;
        button.textContent = originalText;
        return;
      }

      const card = button.closest('.r45-wishlist-card');
      const cardImage = card ? card.querySelector('.r45-wishlist-card__image img') : null;
      if (cardImage && cardImage.src) {
        animateFlyToCart(button, cardImage.src);
      }

      try {
        const cartItemsComponents = document.querySelectorAll('cart-items-component');
        const sectionIds = [];
        cartItemsComponents.forEach(function(item) {
          if (item.dataset && item.dataset.sectionId) {
            sectionIds.push(item.dataset.sectionId);
          }
        });
        const sectionsParam = sectionIds.join(',');

        const trackingProps = typeof window.r45GetTrackingProperties === 'function' ? window.r45GetTrackingProperties() : {};
        const res = await fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: numericVariantId,
            quantity: 1,
            sections: sectionsParam,
            properties: trackingProps
          })
        });

        if (res.ok) {
          const responseData = await res.json();
          button.textContent = translations.added || 'Added!';

          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: responseData,
              sourceId: 'wishlist-' + numericVariantId,
              data: {
                source: 'wishlist',
                variantId: String(numericVariantId),
                sections: responseData.sections || {}
              }
            }
          }));

          setTimeout(function() { button.disabled = false; button.textContent = originalText; }, 1500);
        } else {
          button.disabled = false;
          button.textContent = originalText;
        }
      } catch (e) {
        console.error('Add to cart error:', e);
        button.disabled = false;
        button.textContent = originalText;
      }
    }

    function removeFromWishlist(item, card) {
      if (typeof window._swat !== 'undefined') {
        window._swat.removeFromWishList(item, function() {
          card.remove();
          if (container.children.length === 0) showEmpty();
        });
      }
    }

    async function renderWishlistItems(products) {
      if (!products || products.length === 0) { showEmpty(); return; }

      const seenVariants = {};
      const uniqueProducts = products.filter(function(item) {
        const variantId = String(item.epi);
        if (seenVariants[variantId]) {
          return false;
        }
        seenVariants[variantId] = true;
        return true;
      });

      if (uniqueProducts.length === 0) { showEmpty(); return; }

      hideEmpty();
      hideLoading();
      container.innerHTML = '';

      const itemData = uniqueProducts.map(function(item) {
        return {
          handle: getProductHandle(item.du),
          variantId: item.epi
        };
      });

      const dataPromises = itemData.map(function(data) {
        return data.handle ? fetchProductData(data.handle) : Promise.resolve(null);
      });
      const availPromises = itemData.map(function(data) {
        return data.handle ? fetchVariantAvailability(data.handle, data.variantId) : Promise.resolve({ available: true, inventoryQuantity: null });
      });

      const [dataResults, availResults] = await Promise.all([
        Promise.all(dataPromises),
        Promise.all(availPromises)
      ]);

      uniqueProducts.forEach(function(item, i) {
        const productData = dataResults[i];
        const availData = availResults[i];
        const isAvailable = productData ? availData.available : false;
        const inventoryQuantity = availData.inventoryQuantity;
        const productTitle = availData.productTitle;

        let variantInfo = getVariantInfo(productData, item.epi);
        if (inventoryQuantity !== null) {
          if (!variantInfo) variantInfo = {};
          variantInfo.inventoryQuantity = inventoryQuantity;
        }
        /* Surface the countdown-driven Coming Soon flag we picked up from
           the product page HTML so createCardHtml can disable the cart
           button regardless of whether the merchant still uses the legacy
           COMING SOON tag. */
        if (availData && availData.isComingSoon) {
          if (!variantInfo) variantInfo = {};
          variantInfo.isComingSoon = true;
        }
        const isFirstCard = i === 0;
        container.insertAdjacentHTML('beforeend', createCardHtml(item, productData, isAvailable, variantInfo, isFirstCard, productTitle));
      });

      container.querySelectorAll('.r45-wishlist-card').forEach(function(card, i) {
        const item = uniqueProducts[i];
        initSlider(card);

        const addBtn = card.querySelector('[data-add-to-cart]');
        if (addBtn && !addBtn.disabled) {
          addBtn.addEventListener('click', function() { addToCart(card.dataset.variantId, addBtn); });
        }

        const removeBtn = card.querySelector('[data-remove-wishlist]');
        if (removeBtn) {
          removeBtn.addEventListener('click', function() { removeFromWishlist(item, card); });
        }
      });

      setTimeout(triggerSwipeHint, 500);
    }

    var wishlistInitialized = false;
    var wishlistRendering = false;

    function fetchAndRenderWishlist(forceRefetch) {
      if (wishlistRendering) return;
      if (wishlistInitialized && !forceRefetch) return;

      wishlistInitialized = true;
      wishlistRendering = true;

      showLoading();

      if (typeof window._swat !== 'undefined' && window._swat.fetch) {
        window._swat.fetch(function(products) {
          renderWishlistItems(products);
          wishlistRendering = false;
        });
      } else {
        setTimeout(function() {
          if (typeof window._swat !== 'undefined' && window._swat.fetch) {
            window._swat.fetch(function(products) {
              renderWishlistItems(products);
              wishlistRendering = false;
            });
          } else {
            showEmpty();
            wishlistRendering = false;
          }
        }, 2000);
      }
    }

    if (typeof window.SwymCallbacks === 'undefined') window.SwymCallbacks = [];
    window.SwymCallbacks.push(function(swat) {
      fetchAndRenderWishlist();
    });

    setTimeout(function() {
      if (!wishlistInitialized) fetchAndRenderWishlist();
    }, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWishlistPage);
  } else {
    initWishlistPage();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
